<div class="label">{{ label() }}</div>
<div class="value">
    @if (value() === undefined) {
        <mat-spinner [diameter]="32" />
    } @else if (value() === null) {
        -
    } @else {
        @switch (type()) {
            @case ('number') {
                {{ value() | number }}{{unit()}}
            }
            @case ('currency') {
                {{ value() | number: format() }}{{unit()}}
            }
            @case ('percent') {
                {{ value() | percent }}{{unit()}}
            }
            @default {
                {{ value() }}
            }
        }
    }
</div>

@if (info()) {
    <div class="info">
        {{ info() }}
    </div>
}
